(function () {
  function mountVideo(frame) {
    if (!frame || frame.dataset.loaded === 'true') return;

    var source = frame.getAttribute('data-video-src');
    if (!source || source.indexOf('PLACEHOLDER-') !== -1) {
      frame.classList.add('is-unavailable');
      var unavailableButton = frame.querySelector('.sn-install__play');
      if (unavailableButton) {
        unavailableButton.setAttribute('aria-label', 'Video URL will be added after the original file finishes uploading');
      }
      return;
    }

    var video = document.createElement('video');
    video.controls = true;
    video.playsInline = true;
    video.preload = 'metadata';
    video.setAttribute('controlsList', 'nodownload');

    var sourceElement = document.createElement('source');
    sourceElement.src = source;
    sourceElement.type = 'video/mp4';
    video.appendChild(sourceElement);

    frame.replaceChildren(video);
    frame.dataset.loaded = 'true';
    video.play().catch(function () {});
  }

  function initialize(root) {
    root.querySelectorAll('[data-sn-video]').forEach(function (frame) {
      var play = frame.querySelector('.sn-install__play');
      if (play) play.addEventListener('click', function () { mountVideo(frame); });

    });
  }

  document.querySelectorAll('[data-sn-install]').forEach(initialize);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-sn-install]');
    if (root) initialize(root);
  });
})();
